import React from 'react'

import { useBrandAccountId } from './useBrandAccountId'

export const useMainQueryKey = () => {
  const brandAccountId = useBrandAccountId()

  return React.useMemo(
    () => ['BrandAccountAllowedDomainListPage_Main', brandAccountId],
    [brandAccountId],
  )
}
